import { Injectable } from '@angular/core';
import { AuthTenant } from '@Core/enums/auth-tenant.enum';
import { AuthConfig, Auth0TenantConfig } from '@Core/interfaces/auth-config.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Auth0ConfigService {
  private readonly authConfig: AuthConfig;

  constructor() {
    const tenants: Record<string, Auth0TenantConfig> = {
      [AuthTenant.Primary]: {
        authUri: environment.auth.authUri,
        clientId: environment.auth.clientId,
        redirectUri: environment.baseUrl
      }
    };

    if (environment.altAuth?.authUri && environment.altAuth?.clientId) {
      tenants[AuthTenant.Secondary] = {
        authUri: environment.altAuth.authUri,
        clientId: environment.altAuth.clientId,
        redirectUri: environment.baseUrl + '/altlogin'
      };
    }

    this.authConfig = { tenants };
  }

  getTenantConfig(tenant: AuthTenant): Auth0TenantConfig {
    const config = this.authConfig.tenants[tenant];
    if (!config) {
      throw new Error(`Configuration not found for tenant: ${tenant}`);
    }
    return config;
  }

  getAllTenantConfigs(): AuthConfig {
    return this.authConfig;
  }

  getAvailableTenants(): AuthTenant[] {
    return Object.keys(this.authConfig.tenants) as AuthTenant[];
  }
}
